const es = {
  // =============== A ===============
  "about-our-sun-tops": "Acerca de nuestros Sun Tops",
  "about-pair-eyewear": "Acerca de - Pair Eyewear",
  "about-product": ({ productName }: { productName: string }) => `Acerca de ${productName}:`,
  "about-to-remove": ({ prodcutRemoved }: { prodcutRemoved: string }) => `Estás a punto de eliminar ${prodcutRemoved}.`,
  "about-to-remove-label": "Estás a punto de eliminar",
  "accessories": "Accesorios",
  "account": "Cuenta",
  "accessibility-statement": "Declaración de accesibilidad",
  "account-capitalized": "Cuenta",
  "account-being-activated": "¡Tu cuenta está siendo activada!",
  "account-being-created": "¡Tu cuenta está siendo creada!",
  "account-card-list-items": ({ itemsNumber }: { itemsNumber: string }) => `+ ${itemsNumber} artículos`,
  "account-card-list-item": ({ itemNumber }: { itemNumber: string }) => `+ ${itemNumber} artículo`,
  "account-login-page-title": "Inicio de sesión | Explorar marcos | Pair Eyewear",
  "account-menu": "Menú de cuenta",
  "account-prompt": "¿No tienes una cuenta?",
  "account-rewards-title": "Cuenta - Recompensas",
  "account-rewards-subscriptions": "Cuenta - Suscripciones",
  "accounts-page": "Página de cuentas",
  "activate-account": "Activar cuenta",
  "activate-account-get-started": "Activa tu cuenta | Empezar | Pair Eyewear",
  "add": "añadir",
  "add-od": "Añadir OD",// check translation: OD -> OD
  "add-os": "Añadir OI",// check translation: OS -> OI
  "add-to-cart": "Añadir al carrito",
  "add-to-cart-tops-redirected": "Añadir al carrito + Ir a Tops",
  "add-to-cart-plus": "+ Añadir al carrito",
  "add-uppercase": "Añadir",
  "added": "Añadido",
  "added-to-cart": "Añadido al carrito",
  "added-to-wishlist": "¡Añadido a tu lista de deseos!",
  "add-plus-continue": "Añadir al carrito + Continuar",
  "add-a-top-frame": "Añadir un Top",
  "adding": "Añadiendo",
  "add-to-cart-go-to-tops": "Añadir al carrito y visitar Tops",
  "age-range-5-9": "5-9 años",
  "age-range-8-12": "8-12 años",
  "age-range-9-adult": "9-Adulto",
  "all-about-subscriptions": "Todo sobre suscripciones",
  "all-about-our-subscriptions": "Todo sobre nuestras suscripciones",
  "all-best-things-pairs": "Todo lo bueno viene en pares.",
  "all-duties-and-taxes": "Todos los aranceles e impuestos están incluidos, sin cargos ocultos",
  "all-time": "Todo el tiempo",
  "all-tops": "Todos los Tops",
  "already-have-account-question": ({ signInText }: { signInText: string }) => `¿Ya tienes una cuenta? ${signInText}`,
  "alt-all-tops": ({ label }: { label: string }) => `${label}-tops`,
  "alt-collection-logo": ({ collectionTitle }: { collectionTitle: string }) => `Logo de la colección ${collectionTitle}`,
  "alt-collection": ({ collectionTitle }: { collectionTitle: string }) => `Colección ${collectionTitle}`,
  "alt-side-image": "Imagen lateral",
  "alt-text-blue-swatch": "blue-swatch",
  "attention": "Atención",
  "attention-lowercase": "atención",
  "are-you-sure": "¿Estás seguro?",
  "are-you-want-to-exit": "¿Estás seguro de que quieres salir?",
  "aria-label-previous-slide": "diapositiva anterior",
  "aria-label-previous-slide-capitalized": "Diapositiva anterior",
  "aria-label-next-slide": "siguiente diapositiva",
  "aria-label-next-slide-capitalized": "Siguiente diapositiva",
  "ask-a-stylist": "Pregunta a un estilista",
  "axis": "Eje",
  "axis-od": "Eje OD",// check translation: OD -> OD
  "axis-os": "Eje OI",// check translation: OS -> OI
  // =============== B ===============
  "back": "Volver",
  "back-in-stock": "De nuevo en stock",
  "back-to-my-orders": "Volver a mis pedidos",
  "background-pattern": "patrón de fondo que coincide con el top superior",
  "badge-best": "Más vendido",
  "badge-top-rated": "Mejor valorado",
  "base-frame": "Marco base",
  "base-frame-below-text-1": "Comienza seleccionando un ",
  "base-frame-below-text-2": "marco base a continuación",
  "base-frame-color": "Color del marco base",
  "base-frame-size": "Tamaño del marco base",
  "base-frame-shape": "Forma del marco base:",
  "base-frame-sold-separately": "Marco base se vende por separado",
  "base-frames": "Marcos base",
  "base-frames-benefits": "Por qué te encantarán nuestros marcos base",
  "base-in-bi": "Base Nasal (BN)",// check translation: BI -> BN
  "base-out-bo": "Base Externa (BE)",// check translation: BO -> BE
  "base-up-bu": "Base Superior (BS)",// check translation: BU -> BS
  "base-down-bd": "Base Inferior (BI)",// check translation: BD -> BI
  "basic": "Básico",
  "bifocal-lenses-modern-alternative": "Una alternativa moderna a los lentes bifocales",
  "bl+lr": "Luz Azul + Fotocromáticas",// check translation: BL + LR -> Luz Azul + Fotocromáticas
  "bl": "Luz Azul",// check translation: BL -> Luz Azul,
  "bold": "Atrevido",
  "blue-light": "Luz azul",
  "blue-light-description-screenbound": "Perfecto para quienes trabajan muchas horas frente a una pantalla o computadora cada día",
  "blue-light-description-relieving": "Aumenta el enfoque y reduce los dolores de cabeza",
  "blue-light-description-refreshing": "Reduce la incomodidad ocular, la sequedad y el cansancio",
  "blue-light-description-preventive": "Estudios han demostrado que las gafas de luz azul podrían reducir la probabilidad de degeneración macular relacionada con la edad",
  "blue-light-description-sleep-enhancing": "Duerme mejor con nuestras gafas de luz azul que bloquean los rayos que suprimen la producción de melatonina",
  "blue-light-description-relaxing": "Ideal para reducir la fatiga visual al ver películas",
  "blue-light-description-gamer-friendly": "Mejora tu concentración al jugar videojuegos o hacer videollamadas con amigos y familia",
  "blue-light-description-childproof": "Excelente opción para niños que pasan mucho tiempo frente a tablets, computadoras o TV",
  "blue-light-description-polycarbonate": "Lentes monofocales de policarbonato",
  "blue-light-description-treated": "Todos los lentes incluyen tratamientos superhidrofóbicos, antirreflejo y resistentes a rayones",
  "blue-light-description-add-on": "Disponible por un adicional de $49",// check currency conversion
  "blue-light-description-multifocal": "Un lente progresivo cumple la función de lentes monofocales y de lectura, por lo que solo necesitas un par de gafas",
  "blue-light-description-progressive": "Una mejor opción sin la línea bifocal para quienes usan bifocales",
  "blue-light-description-add-on-249": "Disponible por un adicional de $249",// check currency conversion
  "blue-light-filtering": "Filtrado de luz azul",
  "blue-light-offerings": "Opciones de Lentes para Luz Azul",
  "browser-no-video-support": "Tu navegador no admite la etiqueta de video.",
  "bridge-width-size": ({ bridgeWidth }: { bridgeWidth: string }) => `Ancho del puente: ${bridgeWidth}`,
  "bridge-width-title": "Ancho del puente",
  "bridge-width-description": "El ancho de la sección del puente",
  "buy-more": "Compra más, ahorra más",
  "build-and-purchase": "Construir y comprar",
  "build-bundle-and-save": "Crea tu propio paquete de 3 a 4 Tops y ahorra hasta un 15%",
  "build-from-previous-order": "Construir desde un pedido anterior",
  "build-purchase-edit-frame-save": "Por favor procede a través de 'Construir y comprar' para realizar cambios en el Marco Base elegido en tu carrito. Selecciona 'Actualizar carrito' para guardar tus ediciones más recientes!",
  "build-your-product": ({ productName }: { productName: string }) => `Construye tu ${productName}`,
  "build-you-bundle-title": "Crea tu propio paquete",
  "build-you-bundle-subtitle": "¡Combina y ahorra en tus favoritos! Selecciona un paquete de 3 o 4 Tops. Elige la forma de tu Marco Base, luego selecciona tus Tops. Ahorra un 10% en paquetes de 3 y un 15% en paquetes de 4.",
  "build-you-bundle-size": "Selecciona el tamaño del paquete",
  "build-you-bundle-base": "Selecciona tu Marco Base",
  "build-you-bundle-top": "Selecciona Tops",
  "build-you-bundle-top-title": "¡Completa tu paquete con algunos Tops!",
  "bundle-and-save": "Combínalos y ahorra",
  // =============== C ===============
  "call-doctor-question": "¿Quieres que llamemos a tu doctor?",
  "call-doctor-confirmation": "¡Llamaremos a tu doctor!",
  "cancel": "Cancelar",
  "cart-icon": "Ícono del carrito",
  "color": "Color",
  "color-black": "Negro",
  "color-blue": "Azul",
  "color-blue-clear": "Azul cristalino",
  "color-blue-tortoise": "Azul Carey",
  "color-brown": "Marrón",
  "color-classic-blue": "Azul clásico",
  "color-clear": "Claro",
  "color-crystal-clear": "Transparente",
  "color-gray": "Gris",
  "color-gray-clear": "Gris cristalino",
  "color-green": "Verde",
  "color-green-clear": "Verde cristalino",
  "color-honey-clear": "Miel cristalino",
  "color-lavender-clear": "Lavanda cristalino",
  "color-mixed-material-crystal-clear-silver-metal": "Material Mixto Transparente Metálico Plateado",
  "color-mix-green-gold": "Material Mixto Transparente Metálico Verde Dorado",
  "color-mix-pink-gold": "Material Mixto Transparente Metálico Rosa Claro Dorado",
  "color-mix-tortoise-gold": "Material Mixto Metálico Carey Dorado",
  "color-mixed-material-black-gold-metal": "Material Mixto Metálico Negro Dorado",
  "color-orange": "Naranja",
  "color-pink-clear": "Rosado cristalino",
  "color-pink": "Rosa",
  "color-purple": "Púrpura",
  "color-red": "Rojo",
  "color-rainbow": "Arcoíris",
  "color-tan": "Canela",
  "color-tortoise": "Carey",
  "color-white": "Blanco",
  "color-yellow": "Amarillo",
  "collection": "Colección",
  "collection-uppercase": "Colección",
  "collection-leaving": "¡Colección disponible por poco tiempo!",
  "collection-logo": "logo de colección",
  "collection-title": ({ collectionTitle }: { collectionTitle: string }) => `Colección ${collectionTitle}`,
  "complex-rx-note": "Estos lentes de alto índice 1.67 se recomiendan para recetas complejas, pero no se recomiendan para personas menores de 18 años ya que son menos resistentes a los impactos.",
  "complete-your-order-message": "Completa tu pedido con nuestros accesorios",
  "complete-uncropped-picture": "Una imagen completa y sin recortes de tu receta válida es perfecto",
  "compare": "Comparar",
  "confirm-password": "Confirmar contraseña",
  "continue": "Continuar",
  "continue-entering-rx": "Continuar ingresando receta",
  "continue-to-cart": "Continuar al carrito",
  "continue-shopping": "Continuar comprando",
  "continue-shopping-title-case": "Continuar Comprando",
  "classic": "Clásico",
  "claim-my-free-top": "Reclamar mi Top gratis",
  "cleaning-kit": "Kit de limpieza",
  "cleaning-kit-title": "Kit de limpieza",
  "cleaning-spray-cloth": "Spray y paño de limpieza",
  "clear": "Transparente",
  "clear-all-filters": "Limpiar todos los filtros",
  "clear-filters": "Limpiar filtros",
  "close": "Cerrar",
  "close-filter": "Cerrar filtro",
  "close-this-dialogue": "Cerrar este diálogo",
  "close-microcart-popup": "Cerrar micro carrito",
  "close-uppercase": "Cerrar",
  "click-to-preview": "Haz clic para previsualizar",
  "click-to-upload-file": "Haz clic para subir o arrastra y suelta tus archivos aquí",
  "complete-your-pair": "¡Completa tu par con algunos tops destacados!",
  "contact-customer-service": "Contactar al servicio al cliente",
  "contact-customer-service-suggestion": "Si tienes alguna pregunta o inquietud, no dudes en contactar a nuestro equipo de atención al cliente escribiendo a hello@paireyewear.com o llamando al (646) 389-9692.",// check phone number
  "contact-us": "Contáctanos",
  "contact-us-alternative": ({ contactUs, faq }: { contactUs: string, faq: string }) => `${contactUs} o consulta nuestras ${faq} para obtener ayuda adicional`,
  "contact-us-button-title": "Abre el chatbot de ADA para atención al cliente inmediata",
  "coming-soon": "Próximamente",
  "check-order-status": "Para verificar el estado de tu pedido, por favor ingresa tu número de pedido y dirección de correo electrónico",
  "check-readers-strength": "¡Verifica la graduación de tus lentes para leer!",
  "check-typos-in-search": "Verifica errores tipográficos en la búsqueda",
  "checkout": "Pagar",
  "checkout-collections": "Explora nuestras colecciones",
  "check-pd-in-prescription": "Para procesar tu pedido de inmediato, revisa tu receta para ver si incluye la DP y, si no es así, usa nuestra herramienta para medirla ahora.",// check PD -> DP
  "choose-additional-tops": "Elige Tops adicionales",
  "choose-lens-type": "Elige el tipo de lente",
  "choose-our-top-frames": "¡Elige entre cientos de los mejores Tops para cambiar tu estilo a diario!",
  "choose-subscription": "Elige una suscripción",
  "choose-top-frames": "Elige Tops",
  "choose-your-subscription-top": "1. Elige tu primer top de suscripción",
  "choose-your-subscription-top-v2": "Elige tu primer top de suscripción",
  "choose-your-top": "Elige tu Top",
  "choose-your-tops": "Elige tus Tops",
  "choose-your-lens-type": "Elige tu tipo de lente",
  "choose-your-lens-type-step": "2. Elige tu tipo de lente",
  "create-your-password": "Crea tu contraseña y activa tu cuenta.",
  "create-account": "Crear cuenta",
  "create-an-account-page-title": "Crear una cuenta | Regístrate hoy | Pair Eyewear",
  "create-pair-account": "Crear una cuenta Pair gratis",
  "cylinder": "Cilindro",
  "cylinder-cyl": "CIL",// check translation: CYL -> CIL
  "cylinder-od": "Cilindro OD",
  "cylinder-os": "Cilindro OI",// check translation: OS -> OI
  "crystals": "Cristales",
  "current-selected": "Seleccionado actual",
  "customize-your-lenses": "Personaliza tus lentes",
  "customize-your-lenses-step": "2. Personaliza tus lentes",
  "customer-satisfaction-96": "96% de satisfacción del cliente con esta lente adicional",
  "customer-satisfaction-93": "93% de satisfacción del cliente con este complemento de lente",
  "customer-satisfaction-95": "95% de satisfacción del cliente con estos complementos de lentes",
  // =============== D ===============
  "details": "Detalles",
  "doctor-name-required": "El nombre del doctor o de la clínica es requerido.",
  "doctor-name": "Nombre del doctor o de la clínica",
  "doctor-phone-required": "El teléfono del doctor o de la clínica es requerido.",
  "doctor-phone": "Teléfono del doctor o de la clínica",
  "doctor-state": "Estado/Provincia del doctor o de la clínica",
  "download-invoice": "Descargar factura",
  "decline-invitation": "Rechazar invitación",
  "design": "Diseño",
  "design-your-product": ({ productName }: { productName: string }) => `Diseña tu ${productName}`,
  "discount-code-applied": ({ discountCodeName }: { discountCodeName: string }) => `¡Código de descuento ${discountCodeName} aplicado!`,
  // =============== E ===============
  "earn-hooks": "Ganchos para Orejas",
  "earn-hook-for-your-pair": "Ganchos para orejas para tu par",
  "earn-more-points": "Gana más puntos",
  "earn-points-shopping": "Gana puntos cuando compres",
  "easily-track-order": "Sigue tu pedido fácilmente",
  "edit-bundle": "Edita tu paquete",
  "edit-lense-selection": "Para editar tu selección de lentes, haz clic en el botón de editar en la parte superior del carrito.",
  "edit-pair": "Edita tu par",
  "edit-color": "Editar color",
  "edit": "Editar",
  "enhance-your-pair": "¡Mejora tu par con estos extras para lentes!",
  "eye-doctor-contact": "Se contactará al doctor ocular",
  "empty-cart": "Tu carrito está vacío actualmente",
  "email": "Correo electrónico",
  "email-address": "Dirección de correo electrónico",
  "email-required": "Se requiere el correo electrónico",
  'email-not-valid': "El correo electrónico no es válido",
  "email-subscription-confirmation": "¡Gracias por suscribirte! Por favor revisa tu correo para confirmar tu suscripción.",
  "enter-order-info": "Ingresa la información de tu pedido",
  "enter-order-number": "Por favor ingresa tu número de pedido",
  "enter-only-numeric": "Por favor ingresa solo valores numéricos",
  "enter-prescription-details": "Ingresa los detalles de tu receta",
  "enter-prescription-receive-frame": "¡Ingresar tu receta es la forma más rápida de recibir tus nuevos marcos! Perderás la información de Rx ingresada si sales ahora.",
  "enter-valid-order-number": "Por favor ingresa un número de pedido y correo electrónico válidos.",
  "enter-your-prescription": "Ingresa los detalles de tu receta",
  "entered-manually": "Ingresado manualmente",
  "enter-eye-doc-info": "Ingresa la información de tu doctor ocular y nos comunicaremos para obtener tu receta",
  "enter-eye-doc-info-2": "Ingresa la información de tu doctor ocular y nos comunicaremos para obtener tu receta.",
  "exit": "Salir",
  "extra-15-off": "10% EXTRA DE DESCUENTO",
  "extra-narrow": "Extra Estrecho",
  "extra-wide": "Extra Ancho",
  "explore-all-tops": "Explora todos los Tops",
  "explore-collection": "Explorar colección",
  "explore-favorites": "Explora tus favoritos",
  "explore-product": ({ productName }: { productName: string }) => `Explora ${productName}`,
  "explore-eyewear": "Explora Lentes",
  "explore-sunglasses": "Explora Lentes de sol",
  "explore-the-base": ({ baseName }: { baseName: string }) => `Explora Los ${baseName}`,
  "explore-top-frames": "Explora los Tops",
  "expedite-order-processing": "¡Acelera el procesamiento de tu pedido!",
  "eyeglasses": "Lentes",
  "eye-safety-recommendation": "La selección y uso adecuados de lentes es fundamental para la seguridad de tus ojos. Si tu trabajo, deportes u otras actividades te exponen a riesgos de objetos voladores o impacto físico, puede que necesites materiales especiales de lentes. Recomendamos fuertemente usar lentes resistentes al impacto del tipo Estándar porque tu seguridad, visión y salud ocular son nuestra principal preocupación. Los lentes hechos con materiales Básico o Premium no son tan resistentes al impacto como el material Estándar.",
  "elegant": "Elegante",
  "email-label": "Correo electrónico",
  // ============================== Errors =============================================
  "error-email-subscription": "Ha ocurrido un error. Por favor intenta nuevamente más tarde.",
  "error-notification": "¡Error!",
  "error-occurred-text": "Ha ocurrido un error",
  "error-loading-order-details-message": "Hubo un error al cargar los detalles de tu pedido o el número de pedido no existe. Por favor contacta a nuestro equipo de Servicio al Cliente si fue un error. De lo contrario, haz clic en \"Volver a Mis Pedidos\" para ver tu historial.",
  "error-status-code-exclamation": ({ statusCode }: { statusCode: string }) => statusCode ? `${statusCode} ¡Uy!` : "¡Uy!",
  "error-status-code-500-exclamation": "500 ¡Uy!",
  "error-subscription-submission-upload": "Hubo un error con la subida del formulario. Por favor contacta al Servicio al Cliente.",
  "error-subscription-submission-file-type": "Has seleccionado un tipo de archivo no válido. Por favor sube un archivo con una de las siguientes extensiones:",
  "error-uploading-pd-message": "Por favor recarga esta página e inténtalo de nuevo, o contáctanos y envía tu información directamente a hello@paireyewear.com.",
    // =============== F ===============
  "face-shape-the-serra": "El modelo Serra se ve fantástico en la mayoría de los rostros de niños pequeños, y queda especialmente bien en formas ovaladas, cuadradas u oblongas.",
  "face-shape-the-twain": "El modelo Twain se ve fantástico en la mayoría de los rostros de adultos y niños mayores, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-addison": "El modelo Addison se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-brook": "El modelo Brook se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, cuadradas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-casper": "El modelo Casper se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, en forma de corazón o diamante.",
  "face-shape-the-cedro": "El modelo Cedro se ve fantástico en la mayoría de los rostros de niños pequeños, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-drew": "El modelo Drew se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas o en forma de triángulo.",
  "face-shape-the-ella": "El modelo Ella se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, cuadradas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-finley": "El modelo Finley se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-harper": "El modelo Harper se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-jessie": "El modelo Jessie se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-kirby": "El modelo Kirby se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-larkin": "El modelo Larkin se ve fantástico en la mayoría de los rostros de adultos y niños mayores, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-otero": "El modelo Otero se ve fantástico en la mayoría de los rostros de niños mayores, y queda especialmente bien en formas ovaladas o redondas.",
  "face-shape-the-payton": "El modelo Payton se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, en forma de corazón, oblongas o de triángulo.",
  "face-shape-the-murphy": "El modelo Murphy se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, en forma de corazón, oblongas o de triángulo.",
  "face-shape-the-otis": "El modelo Otis se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, cuadradas u oblongas.",
  "face-shape-the-quinn": "El modelo Quinn se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-reese": "El modelo Reese se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, cuadradas o en forma de diamante.",
  "face-shape-the-soto": "El modelo Soto se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, cuadradas u oblongas.",
  "face-shape-the-wanda": "El modelo Wanda se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, cuadradas, en forma de corazón, diamante o triángulo.",
  "face-shape-the-zuri": "El modelo Zuri se ve fantástico en la mayoría de los rostros de adultos, y queda especialmente bien en formas ovaladas, redondas, cuadradas, en forma de corazón, diamante o triángulo.",
  "favorites": "favoritos",
  "featured-frame-price": ({ frameTitle, frameSelected, framePrice }: { frameTitle: string, frameSelected: string, framePrice: string, }) => `${frameTitle} ${frameSelected}${!!framePrice ? ` ${framePrice}` : ''}`,
  "featured-frame-and-lenses-pricing": ({ frameTitle, frameSelected, framePrice }: { frameTitle: string, frameSelected: string, framePrice: string, }) => `${frameTitle} Lentes ${frameSelected} ${!!framePrice ? ` ${framePrice}` : ''}`,
  "fetching-invoice": "Obteniendo factura...",
  "fit-guide": "Guía de ajuste",
  "fit-and-material": "Ajuste y Material:",
  "fill-out-this-field": "Por favor completa este campo.",
  "filter": "Filtro",
  "filter-toggle-label": ({ filterAction }: { filterAction: string }) => `${filterAction} Filtros`,
  "filters-applied": "Filtros aplicados",
  "first-name": "Nombre",
  "for-home": "Para el hogar",
  "for-work": "Para el trabajo",
  "frame-cases": "Estuches",
  "frame-color": "Color del marco",
  "frame-crafting-instruction": ({ selectedFrame }: { selectedFrame: string }) => `Este Top se hace para encajar instantáneamente en el Marco Base ${selectedFrame}.`,
  "frame-fit-description": (
    { frameName, lensWidth, frameBridge, frameTemple, lensHeight, frameWidth, units }: { frameName: string, lensWidth: string, frameBridge: string, frameTemple: string, lensHeight: string, frameWidth: string, units: string }
  ) => `. ${frameName} mide ${lensWidth}-${frameBridge}-${frameTemple} con una altura de lente de ${lensHeight}${units} y un ancho de cabeza de ${frameWidth}${units}.`,
  "frame-material-acetate": "Acetato",
  "frame-material-metal": "Metal",
  "frame-mix-material-description": "Este marco está hecho de acetato flexible, duradero y pulido a mano con varillas metálicas",
  "frame-sinlge-material-description": "Nuestros marcos están hechos de acetato flexible, duradero y pulido a mano",
  "frame-name-sizing-heading": ({ frameName }: { frameName: string }) => `Tamaño de ${frameName}`,
  "frame-shape": "Forma del marco",
  "frame-shape-cat-eye": "Ojo de gato",
  "frame-shape-round": "Redondo",
  "frame-shape-rectangular": "Rectangular",
  "frame-shape-now-trending": "En tendencia",
  "frame-shape-sporty-spirit": "Deportivo",
  "frame-shape-limited": "Edición limitada",
  "frame-shape-bold": "Atrevido",
  "frame-shape-elegant": "Elegante",
  "frame-size": "Tamaño del marco",
  "frame-size-extra-narrow": "Extra angosto",
  "frame-size-narrow": "Angosto",
  "frame-size-medium": "Mediano",
  "frame-size-wide": "Ancho",
  "frame-size-extra-wide": "Extra ancho",
  "frame-sizing": "Tamaño del marco",
  "frame-width": ({ frameWidth }: { frameWidth: string }) => `Ancho del marco: ${frameWidth}`,
  "frame-width-description": "El ancho del marco es la medida horizontal total del frente de la estructura.",
  "frame-width-paragraph": "El ancho del marco",
  "frame-width-title": "Ancho del marco",
  "frames-adults": "Marcos para adultos",
  "frames-kids": "Marcos para niños",
  "free-shipping": "Envío gratis",
  "free-shipping-and-return": "Envío estándar y devoluciones gratis",
  "free-shipping-countdown": ({ currency, remaining, highlightedText }: { currency: string, remaining: string, highlightedText: string }) => `Te faltan ${currency}${remaining} para ${highlightedText}!`,// check, here the function receives currency values
  "free-shipping-on-plus-orders": ({ currency, threshold }: { currency: string, threshold: string }) => `Envío estándar gratis en pedidos de ${currency}${threshold}+`,// check, here the function receives currency values
  "free-shipping-on-code-orders": ({ countryCode }: { countryCode: string }) => `Envío estándar gratis en todos los pedidos de ${countryCode}`,
  "free-shipping-reward": ({ highlightedText }: { highlightedText: string }) => `🎉 ¡Felicidades! Has desbloqueado ${highlightedText}!`,
  "free-shipping-highlighted-text": "envío gratis",
  "free-shipping-on-over": ({ formattedThreshold }: { formattedThreshold: string }) => `Envío estándar gratis en pedidos superiores a ${formattedThreshold}`,// check, here the function may receives currency values
  "free-shipping-over": ({ threshold }: { threshold: string }) => `Los pedidos superiores a ${threshold} tienen envío gratis`,// check, here the function may receives currency values
  "free-returns-exchange": "Devoluciones o cambios gratis",
  "free-returns-exchange-limitation": "Solo funciona con nuestros Marcos Base",
  "free-trial-30-days": "Prueba sin riesgo de 30 días",
  "free-us-shipping": "Envío estándar gratis en todos los pedidos de EE.UU.",
  "friends-referral-details": "¡Dale a tus amigos $25 de descuento en su primer pedido de $60 (después de descuentos) y recibe $25 (en puntos) por cada referido exitoso!",// check currency conversion
  "for-the-variant": ({ variantOption }: { variantOption: string }) => `para The ${variantOption}`,
  "forgot-your-password": "¿Olvidaste tu contraseña?",
  "fsa-hsa-eligible": "Elegible para FSA y HSA o reembolso por seguro",
  "fsa-hsa-eligible-case": "Las lentes de sol sin receta no son elegibles para FSA o HSA.",
  "fsa-hsa-eligible-sentence-case": "Elegible para FSA y HSA o reembolso por seguro",
  // =============== G ===============
  "get-in-touch": "Contáctanos",
  "get-started": "Comenzar",
  "get-started-selecting": "Comienza seleccionando un ",
  "gift-card": "tarjeta de regalo",
  "gift-card-25": "$25 - Un Top divertido de su elección",// check currency conversion
  "gift-card-50": "$50 - Dos Tops totalmente nuevos",// check currency conversion
  "gift-card-100": "$100 - Marcos Base con receta, un Top y un colgador de pared",// check currency conversion
  "gift-card-200": "$200 - Marco base con receta y filtro de luz azul, dos Tops y + PAIRCare",// check currency conversion
  "gift-card-choose-design": "1. Elige el diseño",
  "gift-card-choose-amount": "2. Escoge la cantidad perfecta",
  "gift-card-tip": "¡Haz el regalo aún mejor con un mensaje divertido!",
  "gift-card-email-instruction": "Te enviaremos el código de la tarjeta de regalo a tu correo electrónico con instrucciones para canjearlo en la compra.",
  "gift-card-guidance": "¿Necesitas ayuda para elegir un regalo?",
  "gift-card-message": "Ya sea que tengas un fanático de los Tops en tu vida o conozcas a alguien que quiera renovar su estilo, ¡regala Pair Eyewear!",
  "gift-card-validation-all-included": "Las tarjetas de regalo son válidas para todos los productos de Pair, incluidos los Marcos Base con o sin receta, Lentes de sol y Tops.",
  "gift-card-validation-simple": "Nuestras tarjetas de regalo no tienen tarifas adicionales de procesamiento. ¡Qué genial!",
  "gift-card-validation-codes": ({ yourSingleWord }: { yourSingleWord: string }) => `Aunque los códigos de descuento no se aplican a la compra de ${yourSingleWord} tarjeta de regalo, el destinatario podrá usar un código de descuento junto con su tarjeta de regalo al momento de pagar`,
      "gift-card-your-single-word": "tu",
  "gift-cards": "Tarjetas de regalo",
  "give-get-25": "Da $25, recibe $25",// check currency conversion
  "get-value": ({ value }: { value: string }) => `Recibe ${value}`,// check, here the function receives currency values
  "give-value": ({ value }: { value: string }) => `Da ${value}`,// check, here the function receives currency values
  "go-back": "Volver",
  "got-it": "Entendido",
  "go-to-rewards": "Ir a mis recompensas",
  "go-to-your-cart": "Ir a tu carrito",
  "got-to-step": ({ stepName }: { stepName: string }) => `Ir al paso ${stepName}`,
  "grateful-phrase-PariCarse": "¡Gracias por agregar PairCare!",
  "great-for-tasks": "• Son ideales para tareas como usar la computadora y leer.",
  "get-frames-faster": "¡Recibe tus marcos más rápido!",
  // =============== H ===============
  "have-us-contact-doctor": "Podemos contactar a tu doctor por ti",
  "help-center": "Centro de ayuda",
  "help-find-order": "Ayúdame a encontrar mi número de orden",
  "hide-word": "Ocultar",
  "horizontal-prism": "Prisma horizontal",
  "horizontal-prism-od": "Prisma H OD",// check translation: OD -> OD
  "horizontal-prism-os": "Prisma H OI",// check translation: OS -> OI
  "how-redeem-points": "¿Cómo canjeo mis puntos?",
  "how-it-works": "Cómo funciona",
  "how-does-it-work": "¿Cómo funciona?",
  "handy-lens-add-ons": "Accesorios útiles para tus lentes",
  "how-use-store-credit": "¿Cómo uso mi crédito en tienda?",
  // =============== I ===============
  "i-have-two-pd-values": "Tengo dos valores de DP",// check translation: PD -> DP
  "ideal-for": "Ideal para:",
  "items-in-order": "Artículos en esta orden",
  "items-counted": ({ itemCount }: { itemCount: string }) => `${itemCount} artículos`,
  "item-counted": ({ itemCount }: { itemCount: string }) => `${itemCount} artículo`,
  "items-added": ({ itemsNumber }: { itemsNumber: string }) => `${itemsNumber} artículos añadidos`,
  "item-added": ({ itemsNumber }: { itemsNumber: string }) => `${itemsNumber} artículo añadido`,
  "include-at-symbol": ({ currentEmailInput }: { currentEmailInput: string }) => `Por favor incluye un '@' en el correo electrónico. A ${currentEmailInput} le falta el '@'.`,
  "included": "Incluido",
  "including-rx": "incluye receta",
  "in-cart": "¡En el carrito!",
  "in-variant": ({ variant }: { variant: string }) => `en ${variant}`,
  "invalid-email-address": "Dirección de correo inválida.",
  "invalid-file-type": "Tipo de archivo inválido",
  "invalid-file-type-reupload": ({ fileTypes }: { fileTypes: string }) => `Tipo de archivo inválido. Por favor sube un archivo con una de las siguientes extensiones: ${fileTypes}.`,
  "image-carousel": "Carrusel de imágenes",
  "image-non-hovered": ({ imageTitle }: { imageTitle: string }) => `${imageTitle} - sin pasar el cursor encima`,
  "image-hovered": ({ imageTitle }: { imageTitle: string }) => `${imageTitle} - con el cursor encima`,
  // =============== J ===============
  "join-pair": "Únete a Pair",
  "join-pair-agreement": ({ termsOfServices, privacyPolicy }: { termsOfServices: string, privacyPolicy:string }) => `Al hacer clic en \"Únete a Pair\", aceptas nuestros ${termsOfServices} y ${privacyPolicy}.`,
  "just-browsing": "Solo estoy viendo",
  "just-launched": "¡Recién lanzado!",
  // =============== K ===============
  "keep-shopping": "Seguir comprando",
  // =============== L ===============
  "label-required": ({ label }: { label: string }) => `${label} es obligatorio`,
  "landing-page-title-blue-light": "Lentes para Luz Azul | Protege tu Visión | Pair Eyewear",
  "landing-page-title-sunglasses": "Lentes de sol en línea | Marcos para Hombres y Mujeres | Pair Eyewear",
  "landing-page-description-blue-light": "Arma unos Lentes para Luz Azul únicos como tú. Encuentra tu marco ideal y elige entre cientos de Tops para completar tu estilo.",
  "landing-page-description-sunglasses": "¡Lentes de sol para cualquier estilo! Nuestros lentes están polarizados y filtran el 100% de los rayos UVA y UVB para proteger tus ojos.",
  "last-action-error": "Tuvimos problemas con tu última acción. Intenta de nuevo más tarde.",
  "last-slide-message": "Esta es la última diapositiva; vuelve a la primera",
  "last-3-months": "últimos 3 meses",
  "last-6-months": "últimos 6 meses",
  "last-name": "Apellido",
  "limited": "Edición Limitada",
  "learn-how": "Aprende cómo",
  "learn-more": "Más información",
  "leave-a-little-note": "Deja una pequeña nota",
  "left-eye-os": "Ojo Izquierdo (OI)",// check translation: OS -> OI
  "lens-type": "Tipo de lente",
  "lens-color": "Color de lente",
  "lens-height": ({ lensHeight }: { lensHeight: string }) => `Altura del lente: ${lensHeight}`,
  "lens-height-description": "Diámetro vertical de un lente",
  "lens-height-title": "Altura del lente",
  "lens-options": "Opciones de lentes",
  "lens-tab-premium-highIndex": "Estos lentes de alto poder y alto índice son ultradelgados, antirreflejantes y resistentes a rayaduras. Esta opción es ideal para graduaciones fuertes (menos de -6.00 o más de +3.00).",
  "lens-tab-blueLight": "Los lentes con filtro de luz azul bloquean rayos potencialmente dañinos emitidos por pantallas o el sol. Si pasas mucho tiempo frente a pantallas, pueden reducir la fatiga visual y mejorar el sueño.",
  "lens-tab-light-responsive": "Si pasas rápidamente de interiores a exteriores, cambiar de lentes puede ser molesto. Estos lentes fotocromáticos se oscurecen al contacto con la luz UV. La tonalidad aumenta con la intensidad del sol. ¡Muy prácticos!",
  "lens-width": ({ lensWidth }: { lensWidth: string }) => `Ancho del lente: ${lensWidth}`,
  "lens-width-title": "Ancho del lente",
  "lens-width-description": "Diámetro horizontal de un lente",
  "lenses": "Lentes",
  "lenses-comfortable-prolonged": "• Estos lentes son cómodos para usarse por periodos prolongados y son ideales para actividades que requieren visión cercana e intermedia, como leer o usar dispositivos digitales.",
  "lenses-ideal-frequent-wearers": "• Estos lentes son perfectos para quienes los usan con frecuencia o por primera vez y buscan una mejor corrección visual.",
  "lenses-packages-basic-copy": "Lentes con claridad óptica.",
  "lenses-packages-standard-copy": "Lentes con claridad óptica y alta resistencia al impacto.",
  "lenses-packages-premium-lozenge": "Mejora Más Solicitada",
  "lenses-packages-premium-copy": "Lentes con claridad óptica hasta 35% más delgados que los básicos. Ideales para graduaciones altas (más de +3.00 o menos de -6.00).",
  "lenses-transition-tint": "Los lentes pasan de transparentes a oscuros cuando están al aire libre",
  "limited-edition": "Edición Limitada",
  "link-pd-with-pair": "Solo necesitamos tu número de orden para vincular tu DP con tu Pair!",// check translation: PD -> DP
  "light-responsive": "Fotocromáticos",
  "log-in": "Iniciar Sesión",
  "log-in-sentence-case": "Iniciar sesión",
  "log-in-for-favorites": "Inicia sesión para acceder a Favoritos",
  "log-in-to-favorite": "Inicia sesión para agregar a tus Favoritos",
  "log-out": "Cerrar sesión",
  "load-more": "Cargar más",
  "loading": "Cargando...",
  "loading-text": "Cargando",
  "loading-text-lowercase": "cargando",
  "loading-collections": "Cargando Colecciones...",
  "looks-like-shopping-tops": "¡Parece que estás viendo Tops!",
  // =============== M ===============
  "make-a-selection": "Haz una selección",
  "manage-pair-membership": "Administra tu membresía PAIR+",
  "manage-your-order": "Ver o administrar tu orden",
  "manually-prescription": "Ingresa tu receta manualmente",
  "material": "Material",
  "measure": "Medir",
  "measure-your-pd": "Ya tenemos tu receta — ahora sólo necesitamos tu distancia pupilar (DP) para comenzar con tus Lentes. Usa nuestra herramienta práctica para medir tu DP ahora.",// check PD -> DP
  "measure-my-pd": "Medir mi DP",// check translation: PD -> DP
  "measuring-tool-issue": "Hmm... Hubo un problema al cargar nuestra herramienta de medición.",
  "measurement-tool-message": "La herramienta de medición sólo se puede usar una vez.",
  "method": "método",
  "members-discount": "Descuento para miembros",
  "medium": "Mediano",
  "monthly-subscription-info-description": "Las suscripciones son perfectas para armar tu colección de Tops mientras ahorras. Si te registras, recibirás un Top preseleccionado (¡con 10% de descuento!) cada mes. Puedes cambiar, pausar, ajustar la frecuencia de entrega o cancelar en cualquier momento.",
  "my-bundle": "Mi Paquete",
  "my-subscription": "Mi Suscripción",
  "my-tab-name": ({ tabName }: { tabName: string }) => `Mis ${tabName}`,
  "my-favorites": "Mis Favoritos",
  "my-favorites-account-title": "Mis Favoritos | Lentes en Línea | Pair Eyewear",
  "my-frames-collection-title": "Mi Colección de Marcos | Lentes en Línea | Pair Eyewear",
  "my-collection": "Mi Colección",
  "my-cart-with-colon": "Mi Carrito:",
  "my-lenses": "Mis Lentes",
  "my-membership": "Mi Membresía",
  "my-orders": "Mis Órdenes",
  "my-orders-account-title": "Mis Órdenes | Rastrear y Administrar | Pair Eyewear",
  "my-prescription": "Mi Receta",
  "my-rewards": "Mis Recompensas",
  "my-subscriptions": "Mis Suscripciones",
  "my-empty-collection-title": "¡Aún no has hecho ningún pedido!",
  "my-empty-collection-paragraph": "Una vez que lo hagas, tus compras aparecerán aquí.",
  "my-top-frames": "Mis Tops",
  "my-base-frame": "Mi Marco Base",
  'month-january': 'Enero',
  'month-february': 'Febrero',
  'month-march': 'Marzo',
  'month-april': 'Abril',
  'month-may': 'Mayo',
  'month-june': 'Junio',
  'month-july': 'Julio',
  'month-august': 'Agosto',
  'month-september': 'Septiembre',
  'month-october': 'Octubre',
  'month-november': 'Noviembre',
  'month-december': 'Diciembre',
  "monthly-store-credit": "Crédito mensual en tienda",
  "member-only-tops": "Tops exclusivos para miembros",
  "membership-options-disclaimer": "Al realizar esta compra, aceptas unirte al Club VIP Pair+ y comprendes que se te cobrará $25/mes, los cuales se convierten en crédito en tienda. Puedes pausar o cancelar en cualquier momento. El primer mes de prueba es gratis.",// check currency conversion
  "member-discount": "Descuento para Miembros",
  "manage-membership": "Administrar Membresía",
  "mocked-review-1-description": "Esta fue mi primera compra en Pair y ahora entiendo por qué son tan populares. ¡La calidad es excelente y poder tener varios estilos en un solo estuche es genial!",
  "mocked-review-2-description": "Han sido muy resistentes a rayones. 1000/10 los recomiendo si buscas lentes duraderos y accesibles.",
  "mocked-review-3-description": "La receta fue precisa, los marcos ajustan bien y los toppers son muy divertidos. El servicio al cliente fue excelente y el envío rápido. ¡Súper recomendados!",
  "more-from-collection": "Más de esta Colección",
  "more-info-incoming": "Más información en camino…",
  "missing-email": "Por favor ingresa tu correo electrónico.",
  // =============== N ===============
  "num-tops": ({ numTops }: { numTops: string }) => `${numTops} Tops`,
  "narrow": "Estrecho",
  "narrow-search-with-favorite-color": "Filtra tu búsqueda por tu color favorito",
  "narrow-search-with-design": "Filtra tu búsqueda por tu diseño favorito",
  "narrowest": "Más estrecho",
  "new": "¡Nuevo!",
  "new-build-your-bundle": "Nuevo: Arma tu propio paquete - Pair Eyewear",
  "new-look-advertisement": "Tu nuevo look comienza con una vista clara.",
  "next-uppercase": "Siguiente",
  "next-collection": "Próxima Colección",
  "next-pair-discount-offer": ({ codeName }: { codeName: string }) => `¡Sólo para tus ojos! Obtén $6 de descuento en tu siguiente Marco Base con el código ${codeName}`,// check currency conversion
  "no-available-filter": "No hay opciones de filtro disponibles",
  "no-order-found": "No se encontró ninguna orden",
  "no-base-frames": "No hay Marcos Base disponibles con estos filtros.",
  "no-results-found": "No se encontraron resultados.",
  "no-results-found-for": ({ query }: { query: string }) => `Parece que no tenemos resultados para ${query}`,
  "no-order-found-message": "No pudimos encontrar esta orden en nuestro sistema.",
  "no-orders-in-time-period": "¡Sin órdenes en este período!",
  "no-orders-found": "¡No tienes órdenes aún!",
  "no-tops-available-for-frame": "No hay tops disponibles para la forma de marco seleccionada",
  "not-found": "No encontrado",
  "not-looking-subscription": "No estoy buscando suscripción",
  "no-favorites-heading": "Actualmente no tienes Favoritos",
  "no-favorites-body": "¡Empieza a explorar y guarda tus Tops favoritos!",
  "none": "Ninguno",
  "no-upgrades": "No quiero personalizar mis lentes",
  "no-upgrades-selected": "Ninguna",
  // =============== O ===============
  "offerings": "Ofertas",
  "one-time": "Una sola vez",
  "one-time-offer-condition": "Esta oferta única solo puede aplicarse a 1 Marco Base y no se puede combinar con otros descuentos.",
  "open-minicart": "Abrir carrito",
  "open-type-dropdown": ({ type }: { type: string }) => `Abrir el menú desplegable de ${type}`,
  "order-confirmation-email": "Revisa tu correo para la confirmación de tu pedido o contáctanos por el chat.",
  "order-line-items": ({ orderItems }: { orderItems: string }) => `(${orderItems} artículos)`,
  "order-number": "Número de pedido",
  "order-number-message": ({ orderNumber }: { orderNumber: string }) => `Pedido #${orderNumber}`,
  "order-number-digit-restriction": "El número de pedido debe contener solo números",
  "order-number-length-restriction": "Tu número de pedido debe tener al menos 5 caracteres.",
  "order-placed": "pedido realizado",
  "order-tracker": "Rastreador de pedidos",
  "orders": "pedidos",
  "orders-placed": "pedidos realizados",
  "ordered-date": ({ orderedDate }: { orderedDate: string }) => `Fecha del pedido: ${orderedDate}`,
  "ordered-previously": "Pedido previamente",
  "original-payment-refund": "Todos los reembolsos se harán al método de pago original — sin excepciones",
  "other-gifts": "Otros regalos geniales",
  "other-items": "Otros artículos",
  "other-similar-to": ({ frameName }: { frameName: string }) => `Otros artículos similares a ${frameName}`,
  "or": "O",
  "or-lowercase": "o",
  "our-specialty": "Nuestra especialidad",
  "our-lenses-description": "Nuestros lentes son polarizados y filtran el 100% de los rayos UVA y UVB para proteger tus ojos. Adiós reflejos y fatiga visual—Hola Pair.",
  // =============== P ===============
  "patient-name-required": "El nombre completo del paciente es obligatorio.",
  "patient-full-name": "Nombre completo del paciente",
  "patient-birthdate-required": "La fecha de nacimiento del paciente es obligatoria.",
  "patient-birthdate": "Fecha de nacimiento del paciente",
  "prescription-photo-uploaded": "Foto de receta cargada",
  "pair-points-reward": ({ pointsBalance }: { pointsBalance: string }) => `Tienes ${pointsBalance} puntos Pair`,
  "pair-points-until-reward": ({ pointsBalance, nextRewardPoints }: { pointsBalance: string, nextRewardPoints: string }) => `${pointsBalance}/${nextRewardPoints} Puntos Pair hasta tu próxima recompensa`,
  "pair-care": "PairCare",
  "pair-care-word-pair": "Pair",
  "pair-care-word-care": "Care",
  "pair-care-coverage-text": ({ faq }: { faq: string }) => `PairCare cubre el costo completo del Marco Base y cualquier adición de lentes. Consulta nuestras ${faq} para más detalles.`,
    "pair-care-coverage-text-highlighted-word": "Preguntas Frecuentes",// check translation: FAQ -> Preguntas Frecuentes
  "paircare-adjusted-price": ({ currencySimbol, oldPrice, newPrice }: { currencySimbol: string, oldPrice: string, newPrice: string }) => `El precio de PairCare se ha ajustado de ${currencySimbol}${oldPrice} a ${currencySimbol}${newPrice} con base en el costo de tus lentes.`,// check, here the function receives currency values
  "pair-care-upsell-state-available-line-1": "Al agregar PairCare a tu pedido, estás tomando la mejor decisión para proteger tu Marco Base.",
  "pair-care-upsell-state-available-line-2": "PairCare es una garantía de un año que cubre Marcos Base, lentes y adiciones si tu Pair se raya o daña dentro del año posterior a la entrega. PairCare no incluye Tops ni cubre robo o pérdida. Para más información visita nuestras Preguntas Frecuentes.",
  "pair-care-upsell-state-pending-line-1": "¡Revisa tu bandeja de entrada! Te enviamos un correo con los detalles del pago.",
  "pair-care-upsell-state-pending-line-2": "Si no encuentras la factura o necesitas ayuda adicional, por favor",
  "pair-eyewear-24": "Pair Eyewear 2024",
  "page-not-found-404": "404 Página no encontrada",
  "page-requested-not-exist": "La página que solicitaste no existe.",
  "pause-play": "pausar/reproducir",
  "past-year": "año pasado",
  "password": "Contraseña",
  "passwords-not-match": "Las contraseñas no coinciden.",
  "please-take-other-peak": "Por favor échale otro vistazo",
  "pd-already-measured": "DP ya medido",// check translation: PD -> DP
  "pd-already-measured-message": "Este pedido ya tiene la DP medida.",// check translation: PD -> DP
  "pd-database-issue": ({ pd }: { pd: string }) => `Tu DP es: ${pd}, pero hubo un problema al guardarla en nuestra base de datos.`,// check translation: PD -> DP
  "pd-not-needed": "No se necesita DP",// check translation: PD -> DP
  "pd-not-needed-message": "Parece que este pedido ya tiene la DP medida o no la necesita.",// check translation: PD -> DP
  "pd-question": "¿Tienes tu DP?",// check translation: PD -> DP
  "pd-received": "¡PD recibida!",
  "pd-received-successfully": ({ pd }: { pd: string }) => `Recibimos tu DP correctamente. Tu DP es: ${pd}. Ya puedes cerrar esta página.`,// check translation: PD -> DP
  "pd-value": "Valor de DP",// check translation: PD -> DP
  "perfect-for-long-screen-time": "Perfecto para quienes pasan mucho tiempo frente a una pantalla",
  "photo-uploaded": "¡Foto cargada!",
  "place-order-remind-later": "No hay problema. Realiza tu pedido ahora y te recordaremos más tarde.",
  "plus-add": "+Agregar",
  "polarized": "Polarizados",
  "polarized-lenses": "Lentes polarizados, resistentes a rayones y que bloquean el 100% de rayos UV",
  "popular-lenses-recommendation": "A la mayoría les encantan sus lentes con estas opciones",
  "popular-search-sparkle": "Brillo",
  "popular-searches": "Búsquedas populares",
  "premium": "Premium",
  "premium-plus": "Premium Plus",
  "premium-progressive": "Progresivos Premier",
  "premium-progressive-offer": "• Los lentes progresivos premier ofrecen un campo visual más amplio y menos distorsión en la visión periférica.",
  "premium-ultra-thin-copy": "Estos lentes de índice alto 1.67 son recomendados para recetas complejas, pero no para menores de 18 ya que son menos resistentes al impacto.",
  "pre-set-saves": "¡Ahorra hasta un 15% con paquetes preestablecidos!",
  "previewing": "Previsualizando",
  "prev-collection": "Colección anterior",
  "prescription-lens-description": "Descripción del lente con graduación",
  "prescription-lens-lineup": "Línea de lentes con graduación",
  "prescription-lens-lowdown": "¡Aquí va todo sobre nuestros lentes con graduación!",
  "privacy-policy": "Aviso de privacidad",
  "privacy-web-form": "Formulario de privacidad en línea",
  "product-suggestions": "Sugerencias de producto",
  "product-may-no-available": "El producto que buscas puede que ya no esté disponible",
  "promotion-code": ({ code }: { code: string }) => `Promoción ${code}`,
  "product-type": "Tipo de producto",
  "progressives": "Progresivos",
  "progressives-tab-digital-freeform": "• Nuestros lentes progresivos Premium se fabrican con tecnología digital Freeform",
  "progressives-tab-bifocal-upgrade": "• Son la versión moderna de los bifocales y trifocales",
  "progressives-tab-add-suitable": "• Si tu receta incluye un valor de ADD y tienes más de 40 años, ¡estos son para ti!",// check abbreviation: ADD -> ADD
  "progressives-tab-varifocal-range": "• Todo lo que necesitas ver en un solo lente: desde leer un libro hasta manejar por la carretera",
  "progressives-tab-premium-coating": "• Incluyen recubrimiento antirreflejante Premium, resistentes a rayones y fáciles de limpiar",
  "pending": "Pendiente",
  "percentage-off": ({ percentageOff }: { percentageOff: string }) => `${percentageOff}% de descuento`,
  "per-delivery": "Por entrega",
  "personalized-shopping-experience": "Para personalizar tu experiencia de compra, indícanos qué Marco Base tienes.",
  "progressive": "Progresivo",
  "protect-your-pair": "Protege tu Pair en nuestro estuche seguro, resistente y ligero.",
  "protect-your-lenses": "Protege tus lentes",
  "protect-your-lens": "Protege tu lente",
  "protect-base": "Protege tu Marco Base",
  "prescription-details-header": "Detalles de la receta",
  "prescription-details-paragraph": ({ productTitle, variantTitle }: { productTitle: string; variantTitle: string }) => `para ${productTitle} en ${variantTitle}`,
  "pair-plus": "PAIR+",
  "pupils-distance-message": "La distancia entre tus pupilas es necesaria para fabricar tus lentes Pair.",
  "pupillary-distance": "Distancia Pupilar",
  "pupillary-distance-od": "DP OD",// check translation: PD -> DP
  "pupillary-distance-os": "DP OI",// check translation: PD -> DP, //check translation: OS -> OI
  // =============== R ===============
  "rainbow-tops": "Tops Arcoíris",
  "rating-score": ({ averageScore }: { averageScore: string }) => `Calificación de ${averageScore}`,
  "reader-strength": "Graduación de lectura",
  "recipient-name": "Nombre del destinatario",
  "refer-a-friend": "RECOMIENDA A UN AMIGO",
  "required": "Requerido",
  "remind-me-later": "Recuérdame más tarde",
  "removed": "Eliminado",
  "remove": "Eliminar",
  "remove-option": "Eliminar opción",
  "remove-lens-selection": " Al hacer esto también eliminarás la selección de lentes. Por favor confirma.",
  "remove-lens-and-subs": " Al hacer esto también eliminarás la selección de lentes y tu suscripción. Por favor confirma.",
  "required-inputs-missing": "Faltan los siguientes campos obligatorios:",
  "readers-strength-error": "Selecciona la graduación de tus lectores para continuar.",
  "readers-magnifying": "• Lentes con aumento para ayudarte a leer mejor",
  "readers-noRx": "• No se necesita receta, solo elige tu graduación ¡y listo!",
  "readers-strengthRange": "• Graduaciones disponibles desde +0.25D hasta +2.75D",
  "readers-premiumCoating": "• Incluyen recubrimiento premium antirreflejante, resistentes a rayones y fáciles de limpiar",
  "recent-order": "Orden reciente",
  "refer-most-recent-rx": "Consulta tu receta más reciente para esta información.",
  "reflective": "Reflectante",
  "refresh": "Actualizar",
  "reset-account": "Reiniciar cuenta",
  "reset-account-password": "Reiniciar contraseña de la cuenta",
  "reset-password": "Reinicia tu contraseña",
  "reset-password-email": "Te enviaremos un correo para restablecer tu contraseña.",
  "reset-password-label": "Restablecer contraseña",
  "review": "Reseña",
  "reviews-total": ({ totalReviews }: { totalReviews: string }) => `${totalReviews} Reseñas`,
  "review-total-none": "Sin reseñas",
  "review-prescription-details": "Revisa los detalles de tu receta",
  "reward-message-less-than-50": "Estás muy cerca. Con 50 puntos obtienes un descuento de $5",// check currency conversion
  "reward-message-50-99": "Tienes $5 para usar en tu próxima compra",// check currency conversion
  "reward-message-100-199": "Tienes $10 para usar en tu próxima compra",// check currency conversion
  "reward-message-200-299": "Tienes $20 para usar en tu próxima compra",// check currency conversion
  "reward-message-300-399": "Tienes $30 para usar en tu próxima compra",// check currency conversion
  "reward-message-400-499": "Tienes $40 para usar en tu próxima compra",// check currency conversion
  "reward-message-500-599": "Tienes $50 para usar en tu próxima compra",// check currency conversion
  "reward-message-600-999": "Tienes más de $60 para usar en tu próxima compra",// check currency conversion
  "reward-message-1000+": "Tienes más de $100 para usar en tu próxima compra",// check currency conversion
  "right-eye-od": "Ojo derecho (OD)",
  "rx-item-first": "¡Necesitamos saber qué elementos aparecen en tu receta antes de continuar!",
  "rx-lens-lineup": "Lentes con receta disponibles",
  "rx-type-is-progressive": ({ rxType, lensPack }: { rxType: string, lensPack: string }) => `${rxType} en ${lensPack}`,
  'rx-type-non-rx': 'Sin receta',
  'rx-type-single-vision': 'Visión sencilla',
  'rx-type-readers': 'Lectura',
  'rx-type-progressive': 'Progresivo',
  'rx-type-premium-progressive': 'Progresivo premium',
  "rx-type-text-sinlge-vision": "Visión Sencilla",
  "rx-type-text-progressives": "Lentes Progresivos",
  "rx-type-text-non-prescription": "Sin receta",
  "rx-type-text-prescription": "Con receta",
  "rxss-field-option-cylinder-label": "Cilindro (CIL) y Eje",// check translation: CYL -> CIL
  "rxss-field-option-prism-label": "Prisma",
  "rxss-field-option-pd": "Distancia Pupilar*",
  "rxss-field-option-pd-tooltip": "No te preocupes si no la tienes. Te guiaremos para medirla en el siguiente paso.",
  "rxss-field-option-sphere-label": "Esfera (ESF)",// check translation: SPH -> ESF
  "rxss-fields-selection-copy": "Marca las medidas que aparecen en tu receta:",
  "rxss-fields-subtitle-copy": "Ingresa tus datos ahora para una entrega más rápida.",
  "rxss-fields-title-copy": "Ten a la mano tu receta para comenzar",
  "rxss-measure-pd-button-copy": "Medir tu Distancia Pupilar",
  "rxss-warning-message": "Estos valores no son comunes, por favor confirma que sean correctos. No necesitas hacer nada si todo está bien.",
  // =============== S ===============
  "save-bundle-edits": "Realiza cambios en el tamaño de tu paquete, forma del Marco Base y selección de Tops. ¡Selecciona \"Actualizar paquete\" para guardar tus ediciones más recientes!",
  "save-color": "Guardar color",
  "save-favorite-items": "Puedes guardar tus artículos favoritos iniciando sesión en tu cuenta de Pair Eyewear. ¡Empieza hoy mismo!",
  "save-time-from-previous": ({ frame, frameColor }: { frame: string, frameColor: string }) => `Ahorra tiempo aplicando la selección de lentes de un pedido anterior a ${frame} en color ${frameColor}`,
  "subscriptions": "suscripciones",
  "subscription": "Suscripción",
  "score-access-to-offers": "Obtén acceso a ofertas y descuentos exclusivos",
  "search-word": "Buscar",
  "search-results-for": "Resultados de búsqueda para:",
  "search-tips": "Consejos de búsqueda",
  "search-suggestions": "Sugerencias de búsqueda",
  "section-best-sellers": "Más Vendidos",
  "section-eyeglasses": "Lentes",
  "section-gradient-crystals": "Cristales Degradados",//check translation
  "section-sun-tops": "Tops de sol",
  "section-spring-daydream": "Día de primavera",
  "section-spring-solids": "Colores sólidos de primavera",
  "section-earthly-spectacles": "Espectáculos terrenales",
  "section-classic-designs": "Diseños clásicos",
  "section-classic-colors": "Colores clásicos",
  "section-cottagecore": "Cottagecore",
  "section-easter": "Pascua",
  "section-jam-fest": "Jam Fest",
  "section-premium-collection": "Colección premium",
  "section-new-arrivals": "Nuevas llegadas",
  "section-home": "Inicio",
  "section-men": "Hombres",
  "section-sparkle-and-shimmers": "Destellos y Brillos",
  "section-sparkles-&-shimmers": "Destellos y Brillos",
  "section-star-wars": "Star Wars™",
  "section-sunglasses": "Lentes de Sol",
  "section-top-frames": "Marcos",
  "section-women": "Mujeres",
  "sent-exclamation": "¡Enviado!",
  "select-frame-shape": "Selecciona la forma del Marco",
  "select-one-or-more": "Selecciona uno o más",
  "select-required-fields": "Selecciona los campos obligatorios",
  "selected": "Seleccionado",
  "seo-metadata-description-top-frames-collections": "Explora lo mejor en lentes con la colección de Tops de Pair Eyewear. Encuentra estilos diversos, desde tendencias atrevidas hasta clásicos que nunca pasan de moda.",
  "seo-metadata-title-bluelight": ({ productName, queryDemo }: { productName: string, queryDemo: string }) => `${productName} | Lentes con Filtro Azul ${queryDemo} | Pair Eyewear`,
  "seo-metadata-title-eyeglasses": ({ productName }: { productName: string }) => `${productName} | Lentes de Prescripción | Pair Eyewear`,
  "seo-metadata-title-pair-sms": "Regístrate para SMS | Actualizaciones y Ofertas por Texto | Pair Eyewear",
  "seo-metadata-title-pair-rewards": "Únete a Pair Rewards | Gana Puntos y Ahorra | Pair Eyewear",
  "seo-metadata-title-pd": "Mide tu Distancia Pupilar | Instrucciones de DP | Pair Eyewear",// check translation: PD -> DP
  "seo-metadata-title-pupillary-measurement": "Cómo medir tu Distancia Pupilar | Instrucciones de DP | Pair Eyewear",// check translation: PD -> DP
  "seo-metadata-title-refer-friend": "Invita a un Amigo | Gana Recompensas | Pair Eyewear",
  "seo-metadata-title-search-results": "Resultados de Búsqueda | Encuentra tus Lentes Ideales | Pair Eyewear",
  "seo-metadata-title-shopping-cart": "Carrito de Compras | Pair Eyewear | Revisa y Paga",
  "seo-metadata-title-talent": "Vacantes Actuales | Únete a Nuestro Equipo | Pair Eyewear",
  "seo-metadata-title-top-frames": ({ productName }: { productName: string }) => `${productName} Top | Pair Eyewear`,
  "seo-metadata-title-top-frames-collections": "Todos los Tops | Descubre las Últimas Colecciones | Pair Eyewear",
  "seo-metadata-title-track-order": "Rastrea tu Pedido | Ver Estado | Pair Eyewear",
  "seo-metadata-title-sunglasses": ({ productName }: { productName: string }) => `${productName} | Lentes de Sol con Prescripción | Pair Eyewear`,
  "suggested-looks": "Estilos que te van a encantar",
  "shop-all-base-frames": "Ver todos los Marcos Base",
  "shop-all-tops": "Ver todos los Tops",
  "shop-collection": "Ver la Colección",
  "shop-glasses": "Ver Lentes",
  "shop-in-local": "Compra en tu moneda local",
  "show-less": "Ver menos",
  "shop-kids": "Niños",
  "show-word": "Mostrar",
  "show-more": "Ver más",
  "shop-men": "Hombres",
  "shop-now": "Comprar",
  "shop-product": ({ productName }: { productName: string }) => `Comprar ${productName}`,
  "shop-top-frame-by-color": "Compra Marcos Superiores por Color",
  "shop-top-frame-by-design": "Compra Marcos Superiores por Diseño",
  "shop-tops": "¡Compra los Tops que has estado mirando!",
  "shop-women": "Mujeres",
  "shimmers": "Brillos",
  "signature-progressive": "Progresivos Signature",
  "signature-lenses-offer": "• Los lentes Signature ofrecen una claridad visual mejorada con mínima distorsión.",
  "status": "Estado",
  "standard": "Estándar",
  "subtotal": "Subtotal",
  "see-all-results": "Ver todos los resultados",
  "select-collection": "Selecciona la colección",
  "select-all-that-apply": "Selecciona todo lo que aplique",
  "select": "Seleccionar",
  "select-any": "Selecciona cualquiera",
  "select-base-frame": "Selecciona un Marco Base",
  "select-measurement-first": "Primero selecciona tu medida",
  "select-strength": "Selecciona la graduación",
  "select-your-lenses": "Selecciona tus lentes",
  "select-your-lenses-step": "1. Selecciona tus lentes",
  "select-your-lenses-step-progressive": "Selecciona tus lentes - Progresivos",
  "select-your-subscription-cadence": "2. Selecciona la frecuencia de tu suscripción",
  "sign-in": "Iniciar sesión",
  "sign-in-sentence-case": "Iniciar sesión",
  "sign-up": "Crear cuenta",
  "similar-to-product": ({ productName }: { productName: string }) => `Similar a ${productName}`,
  "single-vision": "Visión Sencilla",
  "single-vision-tab-diopter-range": "• Para prescripciones de -14.50D a +5.00D",
  "single-vision-tab-lens-focus-range": "• Estos lentes pueden corregir visión de lejos, intermedia o cercana como una sola graduación",
  "single-vision-tab-lens-uv-protection": "• Lentes con materiales de alta calidad y protección UV",
  "single-vision-tab-lens-feature-ar-coating": "• Incluyen recubrimientos premium antirreflejantes, resistentes a rayones y fáciles de limpiar",
  "sizing-for-product": ({ productName }: { productName: string }) => `Medidas para ${productName}`,
  "slide-image-enumarated": ({ index }: { index: string }) => `imagen del slide ${index}`,
  "smoother-transition-zones": "• Las zonas de transición más suaves también significan menos esfuerzo para tus ojos.",
  "sneak-peak-carousel": ({ collectionName }: { collectionName: string }) => `Vista previa de la colección ${collectionName}`,
  "sold-out": "Agotado",
  "sold-out-!": "¡Agotado!",
  "sold-out-notify-me": "Agotado - ¡Notifícame!",
  "sphere": "Esfera",
  "sphere-sph": "SPH",
  "sphere-od": "Esfera OD",
  "sphere-os": "Esfera OI",//check translation: OS -> OI
  "start-referring": "Comienza a invitar",
  "starting-at": "Desde ",
  "starting-from-price": ({ amount }: { amount: string }) => `Desde ${amount}`,// check, here the function receives currency values
  "storage-frames": "Almacenamiento para tus Tops y Marcos Base",
  "submit": "Enviar",
  "submit-if-all-good": "Si todo se ve bien, ¡haz clic en enviar!",
  "submit-prescription": "Enviar receta",
  "subscription-info-description": "Las suscripciones son una forma ideal de hacer crecer tu colección de Pair mientras ahorras dinero. Si te inscribes, recibirás un Top preseleccionado (¡con 10% de descuento!) cada uno, dos o tres meses. Puedes cambiarlo, pausarlo o cancelarlo cuando quieras.",
  "subscription-info-description-p2": "Antes de que se envíe cada pedido de suscripción, recibirás un correo para previsualizar el siguiente Top. Si el Top que viene no es lo que quieres, puedes cambiarlo por otro de nuestros más vendidos.",
  "sun-black": "Sol - Negro",
  "sun-brown": "Sol - Café",
  "sun-green": "Sol - Verde",
  "sun-lens": "Lentes de Sol",
  "sun-lens-offerings": "Opciones de Lentes de Sol",
  "sun-lens-tab-polarized-standard": "Todos nuestros lentes de sol son 100% polarizados",
  "sun-lens-tab-polarized-glare": "Los lentes polarizados reducen el deslumbramiento, ideales para manejar y actividades al aire libre",
  "sun-lens-tab-polarized-colors": "Estos lentes también ofrecen una percepción más precisa de los colores",
  "sun-lens-tab-reflective-glare": "Combinados con los polarizados, los lentes reflectivos maximizan la protección contra el deslumbramiento",
  "sun-lens-tab-reflective-clarity": "Mejor claridad visual al reflejar la luz en lugar de absorberla",
  "sun-lens-tab-reflective-anonymity": "Tus ojos no son visibles, lo que ofrece anonimato",
  "sun-lens-tab-single-vision-price": "Disponible por $99 adicionales",
  "sun-lens-tab-single-vision-price-ca": "Disponible por $99 CAD adicionales",
  "sun-lens-tab-single-vision-price-au": "Disponible por $265 AUD adicionales",
  "sun-lens-tab-single-vision-price-gb": "Disponible por £135 adicionales",
  "sun-lens-tab-single-vision-price-mx": "Disponible por $000 MXN adicionales",// check the correct price
  "sun-lens-tab-progressives-price": "Disponible por $299 adicionales",
  "sun-lens-tab-progressives-price-ca": "Disponible por $299 CAD adicionales",
  "sun-lens-tab-progressives-price-au": "Disponible por $515 AUD adicionales",
  "sun-lens-tab-progressives-price-gb": "Disponible por £310 adicionales",
  "sun-lens-tab-progressives-price-mx": "Disponible por $310 MXN adicionales",// check the correct price
  "sun-tops": "Tops Solares",
  "successful-measure-pd": "DP medido con éxito!",// check translation: PD -> DP
  "swipe-to-view-more": "Desliza para ver más",
  "sporty": "Deportivo",
  // =============== T ===============
  "tag-icon": "ícono-etiqueta",
  "take-on-the-go": "Lleva dos de tus Tops favoritos a donde vayas con nuestro estuche ultra portátil.",
  "tax": "Impuestos",
  "tax-included": "Impuestos incluidos",
  "tab-favorites": "Favoritos",
  "tab-collection": "Colecciones",
  "tab-rewards": "Recompensas",
  "tab-orders": "Pedidos",
  "tap-reward-to-learn": "Toca la recompensa para saber más",
  "take-photo": "Tomar foto",
  "temple-length": ({ templeLength }: { templeLength: string }) => `Largo de varilla: ${templeLength}`,
  "temple-length-description": "La longitud de la varilla, desde el frente del marco hasta la punta",
  "temple-length-title": "Largo de la varilla",
  "terms-of-service": "Términos del servicio",
  "terms-of-services": "Términos del servicio",
  "text-length-validation": ({ length }: { length: string }) => `Por favor, amplía este texto a 5 caracteres o más (actualmente llevas ${length} caracteres).`,
  "time-remaining": "Tiempo restante para el lanzamiento",
  "tooltip-icon": "ícono de sugerencia",
  "total": "Total",
  "total-discount": "Descuento total",
  "tops-label-title": ({ topLabel }: { topLabel: string }) => `${topLabel} Tops`,
  "top-frame-label": "Top",
  "top-frame-option": ({ frameName }: { frameName: string }) => `Top ${frameName}`,
  "top-frames": "Tops",
  "top-frames-attach-explanation": "La magia está en los imanes. Dos imanes invisibles y ultra ligeros (menos de 1 gramo) se colocan en las esquinas superiores del marco, asegurando el Top firmemente.",
  "top-frames-attach-question": "¿Cómo se conectan los Tops a los Marcos Base?",
  "top-frame-cases": "Estuches para Tops",
  "top-frames-fabrication": "Plástico moldeado por inyección, duradero.",
  "top-frames-fabrication-question": "¿De qué están hechos los Tops?",
  "top-frames-question-answer": "Dale personalidad a tus Lentes con cientos de Tops intercambiables que se adhieren instantáneamente a tu Marco Base. Tenemos tops con diseños únicos, colores llamativos, Sun Tops y clásicos.",
  "top-frames-question": "¿Qué son los Tops?",
  "top-frames-thickness": "2mm. Queremos que toda la Familia Pair vea 20/20, por eso nuestros Tops no bloquean tu visión.",
  "top-frames-thickness-question": "¿Qué tan gruesos son los Tops?",
  "top-frames-weight": "El peso de un Top individual va de 2.6 a 3.5 gramos, ¡más ligero que una cucharadita de azúcar! Los Sun Tops suelen pesar 2-3 gramos más por sus lentes.",
  "top-frames-weight-question": "¿Cuánto pesa un Top?",
  "tops-added": ({ topsAdded, topsLimit }: { topsAdded: string, topsLimit: string }) => `${topsAdded}/${topsLimit} Tops añadidos`,
  "tops-bundle-limit": ({ topsLimit }: { topsLimit: string }) => `Paquete de ${topsLimit} Tops`,
  "the-frame": ({ frame }: { frame: string }) => `The ${frame}`,
  "there-was-a-problem": "Ocurrió un problema.",
  "track-order-questions": "¿Quieres seguir tus pedidos y ganar recompensas?",
  "tracking-number": "Número de seguimiento",
  "transition-between-focal-zones": "• La transición entre las diferentes zonas focales es casi imperceptible.",
  "trial-period": "Prueba de 30 días con devoluciones gratis",
  "try-other-design": "Prueba otro color, diseño o colección.",
  "trouble-saving-info": "Tuvimos problemas al guardar tu información. Por favor continúa con el pago y te contactaremos por correo una vez que hagas tu pedido.",
  "true-lowercase": "verdadero",
  "tops-made-for-you": "¡Estos Tops fueron hechos para ti!",
  "trending": "Tendencias",
  // =============== U ===============
  "up-to-wider-distance": "• Con hasta un 32% más de campo visual a distancia y hasta un 46% más de visión cercana, ofrecen mayor comodidad y claridad a cualquier distancia.",
  "upload-prescription": "Subir receta",
  "upload-new": "Subir nuevo",
  "upload-file": "subir",
  "uploaded-file-restrictions": ({ fileTypes, maxSize }: { fileTypes: string, maxSize: string }) => `Archivo ${fileTypes} (tamaño máx. ${maxSize})`,
  "uploaded-pdf-encrypted": "El archivo PDF que subiste parece estar protegido con contraseña. Por favor sube un PDF sin contraseña.",
  "upload-photo": "Subir una foto",
  "update-cart": "Actualizar carrito",
  "update-cart-bundle": "Actualizar paquete",
  "upgrade-your-lenses": "Mejora tus Lentes",
  "upgrade-to-premium-lenses": "Mejora tus lentes con opciones premium: ultra delgados, progresivos y los siguientes",
  "upsell-state-ineligable": "Desafortunadamente, tu pedido tiene más de 30 días y ya no puedes agregar PairCare.",
  "upsell-state-available": "¡Aún estás a tiempo de agregar PairCare – protege tus lentes!",
  "upsell-state-pending": "Estamos esperando el pago para agregar PairCare a tu pedido. ¡Revisa tu bandeja de entrada!",
  "upsell-state-purchased": "¡Sin preocupaciones – ya aseguraste la protección de tus lentes!",
  "use-men-default": "Promedio de Hombres",
  "use-generic-search-terms": "Usa términos de búsqueda más generales",
  "use-women-default": "Promedio de Mujeres",
  "user-comment-location": ({ user, location }: { user: string, location: string }) => `${user} desde ${location}`,
  // =============== V ===============
  "values-provided-uncommon": "Los valores que proporcionaste no son comunes. Por favor confirma que estén correctos y vuelve a enviarlos.",
  "variant-unavailable": "Variante no disponible",
  "variant-unavailable-message": "Esta variante no está disponible para tu Marco Base.",
  "varifocal": "Multifocal",
  "varifocals": "Multifocales",
  "vertical-prism": "Prisma vertical",
  "vertical-prism-od": "Prisma V OD",
  "vertical-prism-os": "Prisma V OI",//check translation: OS -> OI
  "video-thumbnail-5": ({ productType, productName }: { productType: string, productName: string }) => `Miniatura de video ${productType} ${productName} 5`,
  "video-thumbnail": ({ productType, productName, thumbNailIndex }: { productType: string, productName: string, thumbNailIndex:string }) => `Miniatura de video ${productType} ${productName} ${thumbNailIndex}`,
  "view-all-tops": "Ver todos los Tops",
  "view-base-frame": "Ver Marcos Base",
  "view-less": "Ver menos",
  "view-more": "Ver más",
  "view-my-favorites": "Ver mis favoritos",
  "view-order-details": "Ver detalles del pedido",
  "view-product": ({ productOption }: { productOption: string }) => `Ver ${productOption}`,
  "view-products-number": ({ numProducts }: { numProducts: string }) => `Ver productos (${numProducts})`,
  "vip": "VIP",
  "vip-club-membership": "MEMBRESÍA CLUB VIP",
  "vip-promo-description": "Suscríbete por $25/mes que se convierten en crédito en tienda y accede a beneficios exclusivos como miembro Pair+.",// check currency conversion
  "vip-benefit-1": "$25 de crédito mensual en tienda",// check currency conversion
  "vip-benefit-2": "10% extra de descuento en toda la tienda",
  "vip-benefit-3": "Ofertas exclusivas para miembros",
  "vip-benefit-4": "10% adicional en todos los productos",
  "vip-benefit-5": "Puntos según tu nivel de recompensas",
  "vip-benefit-6": "Sin compra mínima para usar tus puntos",
  "vip_price": "PRECIO VIP",
  "vip-sign-up": "Regístrate en el carrito, selecciona la opción 'VIP'. Puedes pausar o cancelar cuando quieras.",
  "virtual-try-on": "Prueba Virtual",
  "view-micro-cart-quantaty": ({ cartQuantity }: { cartQuantity: string }) => `Ver carrito (${cartQuantity})`,
  "view-cart": "Ver carrito",
  // =============== W ===============
  "wall-hangers": "Ganchos para pared",
  "wall-hangers-new-designs": "¡Nuevos diseños increíbles para tus ganchos de pared!",
  "wall-hanger-magic": "Nuestro gancho de pared te permite exhibir mágicamente hasta 5 Tops, ¡e incluso tiene un bolsillo inferior para tu Marco Base!",
  "warranty-1-year": "Garantía de 1 año que cubre completamente lentes rayados o marcos dañados.",
  "welcome-back-text": ({ customerName }: { customerName: string }) => `¡Bienvenido de nuevo, ${customerName}!`,
  "welcome-back-title-case": ({ customerName }: { customerName: string }) => `¡Bienvenido de nuevo, ${customerName}!`,
  "welcome-customer": ({ customerName }: { customerName: string }) => `¡Hola ${customerName}, qué gusto verte!`,
  "welcome-to-pair-eyewear": "Bienvenido a Pair Eyewear",
  "whoops": "¡Ups!",
  "who-is-it-for": "¿Para quién es? (opcional)",
  "why-love-top-frames": "Por qué vas a amar nuestros Tops",
  "wide": "Ancho",
  "widest": "Más ancho",
  "with-your-purchase": "Con tu compra: ",
  "wipe-cart-emoji": "🧨 Vaciar carrito 🧨",
  "word-with": "con",
  "word-price": "Precio",
  "warning-update-password-email": "Te enviamos un correo con el enlace para actualizar tu contraseña.",
  "we-will-notify-you": "Te notificaremos!",
  // =============== Y ===============
  "you-shop-in": ({ localeCopy }: { localeCopy: string }) => `Estás comprando en ${localeCopy}`,
  "your-email": "Tu correo electrónico",
  "your-reward-level": "Tu nivel de recompensa",
  "your-friends-mail": "Correos de tus amigos (separados por comas)",
  "you-pay": "Tú pagas:",
  "you-would-like": "Creemos que te podría gustar",
  "you-unlocked-pair-plus-perks": "Has desbloqueado beneficios de PAIR+",
  // =============== Z ===============
  "zoom": "Zoom"
};

export default es;
